export default "__VITE_ASSET__DJwOjAVu__"